import { Container } from '@mui/material'
import { useUser } from '@src/contexts/AppContext'
import { useDevTools } from '@src/data/types/Constants'
import { Outlet } from 'react-router-dom'
import AlertBanner from './AlertBanner'
import AppHeader from './AppHeader'

const TemplateApp = () => {
  const user = useUser()
  const isIcebergGrDevs = user?.roles.includes('IcebergGrDevs') ?? false
  const showProductionDevelopperAlert = isIcebergGrDevs && !useDevTools
  return (
    <>
      <AlertBanner message="Production" show={showProductionDevelopperAlert} />
      <AppHeader />
      <Container maxWidth="xl" sx={{ mt: 3, pb: 6, overflow: 'auto' }}>
        <Outlet />
      </Container>
    </>
  )
}

export default TemplateApp
